










































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { nodeQuery, companyOperate } from '@/api/project';
import { getPermissions } from '@/utils/utils';
import { nodeMap } from '@/utils/project';
import moment from 'moment';
import roundSelect from '@/components/base/roundSelect.vue';
import { ifLegalCompanyExist, legalCompanyManage } from '@/api/project';
import { meetingCancel } from '@/api/meeting';

const tsSignedStateId = 6;
const portfolioStateId = 7;
interface Node {
  name: String;
  person: String;
  createDate: String;
}

interface Form {
  round: Number | null;
}

@Component({
  components: { roundSelect }
})
class KeyNode extends Vue {
  @Prop()
  companyId;

  @Prop()
  meetingStatusArr;

  @Prop()
  project;

  @Prop()
  roundList;

  @Prop()
  phase;

  @Prop()
  round;

  nodeList: Node[] = [];
  btnsVisible: Boolean = false;
  dialogVisible: Boolean = false;
  formFollowOn: Form = {
    round: null
  };
  rulesFollowOn = {
    round: [
      {
        required: true,
        message: '请选择轮次',
        trigger: 'blur'
      }
    ]
  };
  permissionMap = {};
  legalProjectId = null;

  @Watch('phase')
  phaseChange() {
    this.fetchNodes();
  }

  @Watch('round')
  roundChange() {
    this.fetchNodes();
  }

  @Watch('meetingStatusArr')
  meetingStatusArrChange(val) {
    this.meetingStatusArr = val;
  }

  get hasDealLeader() {
    let { project } = this;
    return project.member && project.member.dls && project.member.dls.length;
  }

  get isTsSigned() {
    let { project } = this;
    return project && project.base && project.base.stateId === tsSignedStateId;
  }

  get isPortfolio() {
    let { project } = this;
    return project && project.base && project.base.stateId === portfolioStateId;
  }

  get isDealLeader() {
    let { project } = this;
    let currentUser = this.$store.state.user.userInfo;
    return ((project.member || {}).dls || []).some(_ => _.id === currentUser.id);
  }

  get isDealMember() {
    let { project } = this;
    let currentUser = this.$store.state.user.userInfo;
    let { sponsorUserIds = [] } = project;
    return ((project.member || {}).dms || []).some(_ => _.id === currentUser.id);
  }

  get isTeam() {
    return this.isDealLeader || this.isDealMember;
  }

  get onlineMeetingStatus() {
    const index = this.meetingStatusArr.findIndex(item => item.meetingType === 1);
    return this.meetingStatusArr[index] ? this.meetingStatusArr[index].status : 0;
  }

  get offlineMeetingStatus() {
    const index = this.meetingStatusArr.findIndex(item => item.meetingType === 2);
    return this.meetingStatusArr[index] ? this.meetingStatusArr[index].status : 0;
  }

  created() {
    this.fetchNodes();
    this.initPermissions();
    this.fetchLegalInfo();
  }

  async fetchNodes() {
    try {
      let { companyId } = this;
      let res = await nodeQuery({
        id: companyId,
        phase: this.phase,
        round: this.round
      });
      let list = res.data || [];
      list.forEach(_ => {
        _.name = nodeMap[_.type];
        _.createDate = moment(_.createAt).format('YYYY-MM-DD');
      });
      this.nodeList = list;
    } catch (e) {}
  }

  async fetchLegalInfo() {
    try {
      let res = await ifLegalCompanyExist({ companyId: this.companyId });
      if (res.code === 200) {
        this.legalProjectId = res.data;
      } else {
        this.legalProjectId = null;
      }
    } catch (e) {}
  }

  initPermissions() {
    let keyList = ['createMeeting', 'ts', 'followOn', 'monitor', 'pass', 'createOfflineMeeting'];
    this.permissionMap = getPermissions(keyList);
  }

  askMeeting(type) {
    this.$emit('askMeeting', type);
    this.hide();
  }

  willCancelMeeting() {
    this.$emit('willCancelMeeting');
    this.hide();
  }

  followOn() {
    // this.dialogVisible = true;
    this.$emit('askMeeting', 0);
    this.hide();
  }

  finishNDA() {}

  operate(type) {
    let textMap = {
      3: this.legalProjectId ? '请确认该项目是否已签TS' : '请确认该项目是否已签TS。此操作会在法务系统中创建项目并绑定到此项目',
      4: '请确认该项目是否已drop TS',
      5: '请确认该项目是否已follow on再融资',
      6: '请确认是否保持关注该项目',
      7: '请确认是否暂不跟进该项目'
    };
    this.$confirm({
      title: textMap[type],
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        this.operateComfirm(type);
      }
    });
  }

  async operateComfirm(type) {
    try {
      if (type === 3 && !this.legalProjectId) {
        await legalCompanyManage({ companyId: this.companyId });
      }
    } catch (e) {}

    try {
      let data;
      let { companyId } = this;
      if (type === 5) {
        let { round } = this.formFollowOn;
        data = { type, round, id: companyId };
      } else {
        data = { type, id: companyId };
      }
      let res = await companyOperate(data);
      if (res.code === 200) {
        this.$message.success('操作成功');
        this.$emit('update');
        this.fetchNodes();
        this.dialogHide();
      }
    } catch (e) {}
  }

  dialogHide() {
    this.dialogVisible = false;
    const form: any = this.$refs.formFollowOn;
    form.clearValidate();
    form.resetFields();
  }

  hide() {
    this.btnsVisible = false;
  }

  cancelofflineMeeting() {
    this.$confirm({
      title: `确定撤回吗?`,
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        this.offlineMeetingCancel();
      }
    });
  }

  async offlineMeetingCancel() {
    try {
      let res = await meetingCancel({
        meetingProjectId: this.companyId
      });
      if (res.code === 200) {
        this.$message.success('撤销成功');
        this.$emit('update');
        // this.hide();
      }
    } catch (e) {
      this.$message.error(e);
    }
  }
}

export default KeyNode;
